import {Button, message} from "antd";
import React, {useEffect, useRef, useState} from "react";
import {useStore} from "@vigo/hooks";
import {WalletActivationModal} from "./WalletActivationModal";

export const ActivateWalletButton = ({courier, reloadCourier, refreshWallet}) => {
    const stores = useStore();
    const isMountedRef = useRef(true);
    const [modalVisible, setModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    const handleActivateWallet = () => {
        setModalVisible(true);
    };

    const handleModalCancel = () => {
        setModalVisible(false);
    };

    const handleModalConfirm = async (processCreditLogs, creditLogStartDate) => {
        setModalVisible(false);
        setLoading(true);
        
        try {
            const result = await stores.walletStore.activateCourierWallet(courier._id, {
                reason: "Cüzdan aktifleştirildi",
                processCreditLogs,
                creditLogStartDate: creditLogStartDate ? creditLogStartDate.toISOString() : null
            });
            
            if (isMountedRef.current) {
                if (result) {
                    message.success("Cüzdan başarıyla aktive edildi.");
                    await reloadCourier(true);
                    refreshWallet();
                } else {
                    message.error("Cüzdan aktifleştirilirken bir hata oluştu.");
                }
            }
        } catch (error) {
            if (isMountedRef.current) {
                message.error("Cüzdan aktifleştirilirken bir hata oluştu.");
            }
        } finally {
            if (isMountedRef.current) {
                setLoading(false);
            }
        }
    };

    if (courier.isWalletActive) {
        return null;
    }
    
    return (
        <>
            <Button 
                type="primary" 
                onClick={handleActivateWallet}
                loading={loading}
                disabled={loading}
            >
                Cüzdanı Tekrar Aktive Et
            </Button>
            
            <WalletActivationModal
                visible={modalVisible}
                onCancel={handleModalCancel}
                onConfirm={handleModalConfirm}
                courierId={courier._id}
            />
        </>
    );
}; 